<template>
    <div class="main">
        <div class="wp4">
            <div class="page-tit dffs">
                <div class="back-btn" @click="goBack"></div>
                开票信息
            </div>

            <div class="application">
                <div class="step">
                    <div class="item" :class="{ active: fir }">
                        <div class="num">1</div>
                        <div class="tit">开票信息填写</div>
                    </div>
                    <div class="item" :class="{ active: second || thir }">
                        <div class="num">2</div>
                        <div class="tit">开票信息确认</div>
                    </div>
                </div>
                <template>
                    <div class="application-inner">
                        <div class="form-item df">
                            <div class="label">开具类型*</div>
                            <div class="con">
                                <div v-if="fir" class="radio-row">
                                    <label v-for="[key, val] in openerTypeMap" :key="key">
                                        <input v-model="formData.openerType" :value="key" class="radio_dot" type="radio"
                                            name="openerTypeRadio" /><span>
                                            {{ val }}
                                        </span></label>
                                </div>
                                <label v-if="second" class="look">{{ formData.openerType | mapFilter(openerTypeMap)
                                    }}</label>
                            </div>
                        </div>
                        <div class="form-item df">
                            <div class="label">发票类型*</div>
                            <div class="con">
                                <div v-if="fir" class="radio-row">
                                    <label v-for="[key, val] in invoiceTypeMap" :key="key">
                                        <input v-model="formData.invoiceType" :value="key" class="radio_dot"
                                            type="radio" name="invoiceTypeRadio" /><span>
                                            {{ val }}
                                        </span></label>
                                </div>
                                <label v-if="second" class="look">{{ formData.invoiceType | mapFilter(invoiceTypeMap)
                                    }}</label>
                            </div>
                        </div>
                        <template v-if="formData.invoiceType != 3">
                            <div class="form-item df">
                                <div class="label">公司名称*</div>
                                <div class="con">
                                    <input v-if="fir" id="companyName" placeholder="请输入公司名称" class="input"
                                        v-model="formData.companyName" autocomplete="off" />
                                    <label v-if="second" class="look">{{ formData.companyName }}</label>
                                </div>
                            </div>
                            <div class="form-item df">
                                <div class="label">统一社会信用代码*</div>
                                <div class="con">
                                    <input v-if="fir" id="taxNo" placeholder="请输入统一社会信用代码" class="input"
                                        v-model="formData.taxNo" autocomplete="off" />
                                    <label v-if="second" class="look">{{ formData.taxNo }}</label>
                                </div>
                            </div>
                            <div class="form-item df">
                                <div class="label">公司地址*</div>
                                <div class="con">
                                    <input v-if="fir" id="companyAddress" placeholder="请输入公司地址" class="input"
                                        v-model="formData.companyAddress" autocomplete="off" />
                                    <label v-if="second" class="look">{{ formData.companyAddress }}</label>
                                </div>
                            </div>
                            <div class="form-item df">
                                <div class="label">公司号码*</div>
                                <div class="con">
                                    <input v-if="fir" id="companyPhone" placeholder="请输入公司号码" class="input"
                                        v-model="formData.companyPhone" autocomplete="off" />
                                    <label v-if="second" class="look">{{ formData.companyPhone }}</label>
                                </div>
                            </div>
                            <div class="form-item df">
                                <div class="label">公司开户行*</div>
                                <div class="con">
                                    <input v-if="fir" id="companyBankName" placeholder="请输入公司开户行" class="input"
                                        v-model="formData.companyBankName" autocomplete="off" />
                                    <label v-if="second" class="look">{{ formData.companyBankName }}</label>
                                </div>
                            </div>
                            <div class="form-item df">
                                <div class="label">开户行账号*</div>
                                <div class="con">
                                    <input v-if="fir" id="companyBankNo" placeholder="请输入开户行账号" class="input"
                                        v-model="formData.companyBankNo" autocomplete="off" />
                                    <label v-if="second" class="look">{{ formData.companyBankNo }}</label>
                                </div>
                            </div>
                        </template>

                        <!-- 个人票 -->
                        <template v-if="formData.invoiceType == 3">
                            <div class="form-item df">
                                <div class="label">个人姓名*</div>
                                <div class="con">
                                    <input v-if="fir" id="personalName" placeholder="请输入个人姓名" class="input"
                                        v-model="formData.personalName" autocomplete="off" />
                                    <label v-if="second" class="look">{{ formData.personalName }}</label>
                                </div>
                            </div>
                            <div class="form-item df">
                                <div class="label">个人证件号*</div>
                                <div class="con">
                                    <input v-if="fir" id="certNo" placeholder="请输入个人证件号" class="input"
                                        v-model="formData.certNo" autocomplete="off" />
                                    <label v-if="second" class="look">{{ formData.certNo }}</label>
                                </div>
                            </div>
                        </template>

                        <div class="form-item df">
                            <div class="label">开票备注*</div>
                            <div class="con">
                                <input v-if="fir" id="invoiceRemark" placeholder="请输入开票备注" class="input"
                                    v-model="formData.invoiceRemark" autocomplete="off" />
                                <label v-if="second" class="look">{{ formData.invoiceRemark }}</label>
                            </div>
                        </div>


                        <div class="form-item df">
                            <div class="label">收件方式*</div>
                            <div class="con">
                                <div v-if="fir" class="radio-row">
                                    <label v-for="[key, val] in receiptTypeMap" :key="key">
                                        <input v-model="formData.receiptType" :value="key" class="" type="radio"
                                            name="receiptTypeRadio" /><span>
                                            {{ val
                                            }}
                                        </span></label>
                                </div>
                                <label v-if="second" class="look">{{ formData.receiptType | mapFilter(receiptTypeMap)
                                    }}</label>
                            </div>
                        </div>

                        <div v-if="formData.receiptType == 2" class="form-item df">
                            <div class="label">收件邮箱*</div>
                            <div class="con">
                                <input v-if="fir" id="receiptEmail" placeholder="请输入收件邮箱" class="input"
                                    v-model="formData.receiptEmail" autocomplete="off" />
                                <label v-if="second" class="look">{{ formData.receiptEmail }}</label>
                            </div>
                        </div>

                        <template v-if="formData.receiptType == 1">
                            <div class="form-item df">
                                <div class="label">收件人*</div>
                                <div class="con">
                                    <input v-if="fir" id="receiptName" placeholder="请输入收件人" class="input"
                                        v-model="formData.receiptName" autocomplete="off" />
                                    <label v-if="second" class="look">{{ formData.receiptName }}</label>
                                </div>
                            </div>
                            <div class="form-item df">
                                <div class="label">联系方式*</div>
                                <div class="con">
                                    <input v-if="fir" id="receiptMobile" placeholder="请输入收件人联系方式" class="input"
                                        v-model="formData.receiptMobile" autocomplete="off" maxlength="11" />
                                    <label v-if="second" class="look">{{ formData.receiptMobile }}</label>
                                </div>
                            </div>
                            <div class="form-item df">
                                <div class="label">收件人地址*</div>
                                <div class="con">
                                    <input v-if="fir" id="receiptAddress" placeholder="请输入收件人地址" class="input"
                                        v-model="formData.receiptAddress" autocomplete="off" />
                                    <label v-if="second" class="look">{{ formData.receiptAddress }}</label>
                                </div>
                            </div>
                        </template>
                    </div>

                    <div class="btn-group">
                        <a v-if="second" href="javascript:;" class="btn " @click="pre">
                            <span>上一步</span>
                        </a>
                        <a href="javascript:;" class="btn theme" @click="next" v-if="fir">
                            <span>下一步</span>
                        </a>
                        <a href="javascript:;" v-if="second" class="btn theme" :disabled="isSubmit" @click="submit">
                            <span>确认提交</span>
                        </a>
                    </div>

                </template>
            </div>

        </div>
    </div>
</template>

<script>
import { industryApi } from '@/api/industry';
const openerTypeMap = new Map([
    [1, '纸质发票'],
    [2, '电子发票']
])

const invoiceTypeMap = new Map([
    [1, '企业普票'],
    [2, '企业专票'],
    [3, '个人普票']
])

const receiptTypeMap = new Map([
    [1, '邮寄'],
    [2, '邮件']
])

export default {
    data() {
        return {
            openerTypeMap: openerTypeMap,
            invoiceTypeMap: invoiceTypeMap,
            receiptTypeMap: receiptTypeMap,
            jumpT: 3,
            fir: true,
            second: false,
            thir: false,
            isSubmit: false,
            formData: {
                id: '',
                openerType: 1,
                invoiceType: 1,
                companyName: '',
                taxNo: '',
                companyAddress: '',
                companyPhone: '',
                companyBankName: '',
                companyBankNo: '',
                invoiceRemark: '',
                personalName: '',
                certNo: '',
                receiptType: 1,
                receiptEmail: '',
                receiptName: '',
                receiptMobile: '',
                receiptAddress: ''
            }
        }
    },
    created() {
        this.formData.id = this.$route.params.payId
        if (!this.formData.id) {
            this.$message.warning('找不到对应的支付信息，请重试');
            this.goBack();
            return;
        }
        let invoiceObj = this.$session.get("invoice");
        if (invoiceObj.invoiceStatus == 1) {
            for (let i in this.formData) {
                this.$set(this.formData, i, invoiceObj[i]);
            }
        }
    },
    destroyed() {
        this.$session.remove("invoice");
    },
    methods: {
        getDefaultFormData() {
            return {
                id: '',
                openerType: 1,
                invoiceType: 1,
                companyName: '',
                taxNo: '',
                companyAddress: '',
                companyPhone: '',
                companyBankName: '',
                companyBankNo: '',
                invoiceRemark: '',
                personalName: '',
                certNo: '',
                receiptType: 1,
                receiptEmail: '',
                receiptName: '',
                receiptMobile: '',
                receiptAddress: ''
            };
        },
        resetForm() {
            this.formData = this.getDefaultFormData(); // 重置表单数据
            this.$nextTick(() => {
                this.$router.push({
                    name: 'newPaymentList'
                });
            });
        },
        goBack() {
            this.resetForm()
        },

        pre() {
            if (this.fir) {
                this.goBack();
            }

            if (this.second) {
                this.fir = true;
                this.second = false;
                window.scrollTo(0, 0);
            }
        },
        next() {
            if (!this.checkForm()) {
                return;
            }
            this.fir = false;
            this.second = true;
            window.scrollTo(0, 0);
        },
        delParam(arr, params) {
            arr.forEach((key) => {
                delete (params[key]);
            })
            return params
        },
        submit() {
            this.isSubmit = true;
            let params = {
                ...this.formData
            }
            if (this.formData.invoiceType == 3) {
                let arr = ['companyName', 'taxNo', 'companyAddress', 'companyPhone', 'companyBankName', 'companyBankNo'];
                params = this.delParam(arr, params);
            } else {
                let arr = ['personalName', 'certNo'];
                params = this.delParam(arr, params);
            }

            if (this.formData.receiptType == 1) {
                let arr = ['receiptEmail'];
                params = this.delParam(arr, params);
            } else {
                let arr = ['receiptName', 'receiptMobile', 'receiptAddress'];
                params = this.delParam(arr, params);
            }

            industryApi.invoice(params).then(res => {
                if (res.code == 200) {
                    this.$message.success('成功提交');
                    setTimeout(() => {
                        this.goBack();
                    }, 500);
                }
            }).finally(() => {
                this.isSubmit = false;
            })
        },
        checkForm() {
            var data = $(".ipts").serialize();
            var array = data.split("&");
            for (var i = 0; i < array.length; i++) {
                var arr = array[i].split("=");
                var len = $(".inputRequired").length;
                for (var j = 0; j < len; j++) {
                    let _this = $(".inputRequired").eq(j);
                    const value = _this.val();
                    if (value == null || value == "") {
                        this.$message(_this.attr('placeholder'));
                        _this.focus();
                        return false;
                    }
                }
            }

            if (this.formData.receiptType == 1 && !this.$isPhone(this.formData.receiptMobile)) {
                this.$message("请输入正确的联系方式");
                $("#receiptMobile").focus();
                return false;
            }
            if (this.formData.receiptType == 2 && !this.$isEmail(this.formData.receiptEmail)) {
                this.$message("请输入正确的收件邮箱");
                $("#receiptEmail").focus();
                return false;
            }

            return true;
        }
    }
}
</script>
<style scoped>
.look {
    font-size: 16px;
    font-weight: 500;
}

.form-item.df {
    display: flex;
    align-items: center;
}
</style>
